export default "__VITE_ASSET__6YUtO0Mz__"